import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {LandingPageContent} from '@/constants';
import {Routes} from '@/navigation/Routes';
import {TermsConditionModal} from '@/components/common/TermsConditionModal';
import {SecurityPolicyModal} from '@/components/common/SecurityPolicyModal';
import {authStatus} from '@/services/redux/selectors';

export const FooterBottom: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector(authStatus);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isSecurityModalOpen, setIsSecurityModalOpen] = useState(false);

  return (
    <>
      <div className="bg-ui_blue_background w-full flex justify-center md:justify-end gap-4 md:gap-6 px-4 md:px-9 py-4 md:py-6 border-t border-ui_input_border">
        {LandingPageContent.footer.bottom.map(item => (
          <span
            key={item.label}
            onClick={() => {
              if (isAuthenticated) {
                if (item.link === Routes.TERMS) {
                  setIsTermsModalOpen(true);
                } else if (item.link === Routes.PRIVACY) {
                  setIsSecurityModalOpen(true);
                }
              } else {
                navigate(item.link);
              }
            }}
            className="font-FigtreeRegular text-xs md:text-sm text-white cursor-pointer hover:underline">
            {item.label}
          </span>
        ))}
      </div>
      <TermsConditionModal isOpen={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} />
      <SecurityPolicyModal isOpen={isSecurityModalOpen} onClose={() => setIsSecurityModalOpen(false)} />
    </>
  );
};
